import { InjectedStyledComponent } from '../InjectedStyledComponent';
import ListItem from './ListItem';

export default InjectedStyledComponent(ListItem, 'shared', ['dropdownListItem']);